import React, { FC } from 'react';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionOrderSearchItem } from '@interfaces/search';
import ProductionOrderContentWrapper from './components/ProductionOrderContentWrapper';
import { useHandleNavigationContextHeader } from '@v2/pages/common/hooks/useHandleNavigationContextHeader';
import { LevelSubScreen } from '@v2/pages/common/enums';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface ProductionOrderDetailsProductionOrderTimelineProps extends ProductionOrderScreenProps {
  productionOrders: ReducerEntityWithLoadingState<ProductionOrderSearchItem[]>;
}

const ProductionOrderDetailsProductionOrderTimelineComponent: FC<ProductionOrderDetailsProductionOrderTimelineProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  productionOrders,
}) => {
  const title = useTitle();
  const { activeLevelSubScreenName } = useHandleNavigationContextHeader();

  const productionOrder = productionOrders.data?.[0];
  const loading = !productionOrders.wasLoaded;

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
  });

  return (
    <ProductionOrderContentWrapper
      activeLevelSubScreenName={activeLevelSubScreenName as LevelSubScreen}
      loading={loading}
      productionOrder={productionOrder}
    >
      <DetailsPageWrapper title={title.productionOrder}>
        <MultiMachineTimeline fullScreen={false} />
      </DetailsPageWrapper>
    </ProductionOrderContentWrapper>
  );
};

const ProductionOrderDetailsProductionOrderTimeline = connect(
  ({ details: { productionOrders } }) => ({ productionOrders }),
  {
    productionOrdersSearch,
    updateHeaderConfig,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
  }
)(ProductionOrderDetailsProductionOrderTimelineComponent);

export { ProductionOrderDetailsProductionOrderTimeline };
